require('./chartList.css');

var tmpl = require('./chartList.ejs');
var tmplItem = require('./chatItem.ejs');

var ChartList = function () {
    this.ids = {};
    this.datas = [];
    this.init();
    this.sends = [];
    this.listHeight = 0;
    this.scrollTop = 0;
};

ChartList.prototype.init = function () {
    this.isScroll = false;//非手动滚动状态
    this.initDom();
    this.initEvent();
};

ChartList.prototype.initDom = function () {

    this.el = $(tmpl());

    this.elList = $(this.el).find('.c-chart__list')[0];
    this.elItems = $(this.elList).children();
    this.elMore = $(this.el).find('.c-chart__message')[0];
    this.listHeight = this.elList.scrollTop;
    this.isScroll = true;
};

ChartList.prototype.initEvent = function () {
    var _self = this;

    $(this.elList).on('scroll', function () {
        var scrollTop = $(this).scrollTop();

        if (scrollTop == 0) {
            _self.elList.scrollTop = 1;
            return;
        }
        var divHeight = _self.elList.offsetHeight;
        var listHeight = _self.elList.scrollHeight;

        if (listHeight == scrollTop + divHeight) {
            _self.isScroll = true;
            _self.elMore.style.display = 'none';

        }else{
            _self.isScroll = false;

        }
    });

    $(this.elMore).on('click', function () {
        var offset = $(_self.elList).children().length;
        _self.isScroll = true;
        _self.scrollTo(offset-1);
        this.style.display = 'none';
    });


};


ChartList.prototype.fliterDatasBySend = function (datas) {
    var result = [];
    var item;
    for (var i = 0, iLen = datas.length; i < iLen; i++) {
        item = datas[i];
        var isSelect = false;
        for (var j = 0, jLen = this.sends.length; j < jLen; j++) {
            if ((this.sends[j].content == item.content) && (this.sends[j].nickname == item.nickname)) {
                this.sends.splice(j, 1);
                isSelect = true;
                break;
            }
        }
        if (!isSelect) {
            result.push(item);
        }
    }
    return result;
};

ChartList.prototype.fliterDatas = function (datas) {
    datas = this.fliterDatasBySend(datas);
    var result = [];
    var item, strId;
    for (var i = 0, iLen = datas.length; i < datas.length; i++) {
        item = datas[i];
        strId = item.id + '';
        if (strId.indexOf('sendBack_') >= 0) {
            this.sends.push(item);
        }
        if (!this.ids[item.id]) {
            this.ids[item.id] = true;
            result.push(item);
        }
    }
    return result;
};

ChartList.prototype.add = function (type,datas) {

    datas = this.fliterDatas(datas);

    datas = this.datas.concat(datas);

    this.datas = [];

    // 如果过滤后的数据为空的话，则不进行下面的操作。

    if (datas.length <= 0) {
        return;
    }

    var baseLength = $(this.elList).children().length;
    var dataitem , result = [];
    for( var i = 0;i < datas.length; i++) {
        dataitem = {};
        dataitem = datas[i];
        dataitem.offset = baseLength + i;
        dataitem.avatar = decodeURIComponent(dataitem.avatar);//测试中发现有个别是乱码
        if(type == 'gift'){
            //var gift = {};

            dataitem.avatar = dedataitem.user.avatar;
            dataitem.nickname = dataitem.user.nickname;
            dataitem.comboname = dataitem.gift.comboname;
            //dataitem.combo = dataitem.gift.combo;
            dataitem.giftImg = dataitem.gift.combosrc;
        }
        result.push(dataitem);
    }

    var div = tmplItem({list: result,type:type});

    $(this.elList).append(div);


    var last = $(this.elList).children().length-1;
    var elm = $('[data-offset="' + last + '"]')[0];

    var newTop = $(elm).position().top;
    var top = $(this.elList).scrollTop();

    var divHeight = this.elList.offsetHeight;

    if (this.isScroll && (this.listHeight >= this.scrollTop + divHeight || this.listHeight < divHeight)) {
        this.scrollTo(last);
        this.elMore.style.display = 'none';
    } else {
        this.elMore.style.display = 'block';
    }

    this.listHeight = this.elList.scrollHeight;

};

ChartList.prototype.scrollTo = function (offset) {

    var elm = $('[data-offset="' + offset + '"]')[0];
    if (elm) {
        var newtop = $(elm).position().top;
        var top = $(this.elList).scrollTop();

        $(this.elList).animate({scrollTop: top+newtop}, 100);
    }
};

ChartList.prototype.scroll = function () {
    var listHeight = this.elItems.offsetHeight;
    var scrollTop = this.elList.scrollTop;
    var divHeight = this.el.offsetHeight;
    if (listHeight > scrollTop + divHeight) {
        this.elList.stop()
            .animate({scrollTop: listHeight - divHeight}, 400);
    }
};

ChartList.prototype.renderTo = function (parentNode) {
    //console.log($(this.el));
    this.targetDom = parentNode;
    parentNode.append($(this.el));

};

ChartList.prototype.destory = function () {
    this.el.parentNode.removeChild(this.el);
};

ChartList.prototype.resize = function () {
    this.elList.style.height = this.el.offsetHeight + 'px';
};

ChartList.prototype.clear = function () {

    this.elList.innerHTML = '';
    //this.el.parentNode.removeChild(this.el);

};
ChartList.prototype.appendInfo = function (type,data) {
    //console.log(data);
    var itemLen = $(this.elList).children().length;
    data[0].offset = itemLen;
    //console.log("发送消息的信息==",data);

    //显示在消息框
    var div = tmplItem({list: data,type:type});
    $(this.elList).append(div);

    //消息自动往上推
    var last = itemLen-1;
    var elm = $('[data-offset="' + last + '"]')[0];

    var newTop = $(elm).position().top;//相对于 父元素
    var top = $(this.elList).scrollTop();
    var divHeight = this.elList.offsetHeight;//消息框高度

    //console.log(this.listHeight,this.scrollTop,divHeight);
    if (this.isScroll && (this.listHeight >= this.scrollTop + divHeight || this.listHeight < divHeight)) {
        this.scrollTo(last);
        this.elMore.style.display = 'none';
    } else {
        this.elMore.style.display = 'block';
    }
    this.listHeight = this.elList.scrollHeight;

    //将发送的存入过滤栈
    var mesInfo = {
        content : data[0].content,
        nickname : data[0].nickname
    }
    this.sends.push(mesInfo);  //已显示

};
module.exports = ChartList;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/chartList/index.js